import { Action } from "redux";
import { ICustomerTopPageActionCreator } from "../action/customer_top_page_action";

interface ICustomerTopPageDispatcher {
  getMeCustomer(): void;
}

class Dispatcher implements ICustomerTopPageDispatcher {
  constructor(
    private dispatch: (action: Action) => void,
    private actionCreator: ICustomerTopPageActionCreator
  ) {}

  public getMeCustomer = (): void => {
    this.dispatch(this.actionCreator.requestGetMeCustomerByTopPageAction());
  };
}

const createCustomerTopPageDispatcher = (
  dispatch: (action: Action) => void,
  actionCreator: ICustomerTopPageActionCreator
): ICustomerTopPageDispatcher => {
  return new Dispatcher(dispatch, actionCreator);
};

export { createCustomerTopPageDispatcher, ICustomerTopPageDispatcher };



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/customer_top_page_dispatcher.ts